<template>
    <div class="vue-root">
        <ul>
            <li :class="{ active: char == filterkey }">
                <button v-on:click="filterkey = ''; mode='list'">Alle</button>
            </li>
            <li v-for="char in letters" :class="{ active: char == filterkey }">
                <button v-on:click="filterkey = char; mode='list'">{{ char }}</button>
            </li>
        </ul>

        <div class="glossary_messages" v-if="mode == 'single'">
            <div class="detail" v-for="item in singleItem">
                <h3>{{ item.title }}</h3>
                <div class="text" v-html="item.description"></div>
            </div>
        </div>

        <div class="glossary_messages" v-else>
            <template v-if="filterkey == ''">
                <div v-for="item in glossaries" class="item">
                    <button v-on:click="loadItem(item)">{{ item.title }}</button>
                </div>
            </template>
            <template v-else>
                <div v-for="item in glossarFiltered" class="item">
                    <button v-on:click="loadItem(item)">{{ item.title }}</button>
                </div>
                <div v-if="glossarFiltered.length == 0" class="item">
                    {{t('general.noentry')}}
                </div>
            </template>

        </div>
    </div>
</template>

<script>
import gql from 'fake-tag';
import { FireI18n } from 'fire-js-i18n';

export default {
    name: 'Glossary',
    components: {},
    props: {
        glossaryId: ''
    },
    data: () => ({
        glossaries: [],
        glossarFiltered: [],
        filterkey: '',
        singleItem: [],
        char: '',
        mode: 'list'
    }),
    computed: {
        letters()
        {
            let letters = []
            for(let i = 'A'.charCodeAt(0); i <= "Z".charCodeAt(0); i++)
            {
                letters.push(String.fromCharCode([i]))
            }
            letters.push('#');
            return letters;
        }
    },
    watch: {
        filterkey()
        {
            this.glossarFiltered = this.glossaryByChar(this.filterkey);
        }
    },
    methods: {
        loadData()
        {
            const limit = -1;
            const body = {
                query: gql`query getGlossaries($limit: Int!)
                    {
                        glossaries(limit: $limit, offset: 0, sortBy: GLOSSARY_TITLE_ASC) {
                            results {
                                id
                                glossaryId
                                char
                                title
                                description
                                errors
                                pageUrl
                            }
                        }
                    }`,
                variables: {
                    limit
                }
            };

            fetch(graphqlApi, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': yii.getCsrfToken()
                },
                body: JSON.stringify(body)
            })
                .then(res => res.json())
                .then(res =>
                {
                    this.glossaries = res.data.glossaries.results;
                    this.singleItem = this.glossarById(this.glossaryId);
                    if (this.glossaryId > 0){
                        this.mode='single';
                    }
                });
        },
        t(key, options)
        {
            return FireI18n.t(key, options);
        },
        glossaryByChar: function(char)
        {
            let glossarmessages = this.glossaries.filter(dataSet => dataSet.char == char);
            if(glossarmessages.length > 0)
            {
                return glossarmessages;
            }
            return [];
        },
        glossarById: function(id)
        {
            let glossarEntry = this.glossaries.filter(dataSet => dataSet.glossaryId == id);
            if(glossarEntry.length > 0)
            {
                return glossarEntry;
            }
            return [];
        },
        loadItem: function(item)
        {
            //set char / single item
            this.filterkey = item.char;
            this.mode = 'single';
            this.singleItem = this.glossarById(item.glossaryId);
            let stateData = {
                'filterkey': this.filterkey,
                'singleItem': this.singleItem,
                'mode': this.mode
            };
            //change url
            history.pushState(stateData,item.title, item.pageUrl);
        },
        onPopStateChange(event)
        {
            // console.log(event);
            if (history.state){
                console.log(history.state)
                this.filterkey = history.state.filterkey;
                this.singleItem = history.state.singleItem;
                this.mode = history.state.mode;
            }
        }
    },
    mounted()
    {
        this.loadData();
    },
    created()
    {
        window.onpopstate = this.onPopStateChange.bind(this);
    }
}

</script>